<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isServiceAdmin()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-secondary"
                                @click="serviceCategoryReport"
                            >
                                <i class="fas fa-book"></i> Service Category
                                Report
                            </button>
                            &nbsp;
                            <button
                                type="button"
                                class="btn btn-tool btn-secondary"
                                @click="serviceStatusReport"
                            >
                                <i class="fas fa-book"></i> Service Status
                                Report
                            </button>
                            &nbsp;
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-md-12 float-left">
                            <div class="row">
                                <div class="col-sm-4 float-left">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >No. of results per page:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            min="5"
                                            value="10"
                                            v-model="results"
                                            placeholder=" Enter No. of results"
                                            @input="getJobs('/api/getAllJobs')"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Item Name (ERP):</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="item_name"
                                            placeholder="Enter the item name"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Division:</span
                                        >
                                        <v-select
                                            v-model="division"
                                            class="form-control"
                                            type="text"
                                            label="division_name"
                                            :options="divisions"
                                            :reduce="
                                                (divisions) =>
                                                    divisions.division_name
                                            "
                                            name="division"
                                            placeholder="Select Division Category"
                                            :value="
                                                (divisions) =>
                                                    divisions.division_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Item Category:</span
                                        >
                                        <v-select
                                            v-model="item_category"
                                            class="form-control"
                                            type="text"
                                            label="category_name"
                                            :options="categories"
                                            :reduce="
                                                (categories) =>
                                                    categories.category_name
                                            "
                                            name="category"
                                            placeholder="Select Item Category"
                                            :value="
                                                (categories) =>
                                                    categories.category_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Product:</span
                                        >
                                        <v-select
                                            v-model="product"
                                            class="form-control"
                                            type="text"
                                            label="product_name"
                                            :options="products"
                                            :reduce="
                                                (products) =>
                                                    products.product_name
                                            "
                                            name="product"
                                            placeholder="Select Product Category"
                                            :value="
                                                (products) =>
                                                    products.product_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Mobile Number:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="customer_phone"
                                            placeholder="Enter the customer number"
                                            min="1000000000"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select TAT Condition:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="tat"
                                        >
                                            <option value="1">Over TAT</option>
                                            <option value="0">Under TAT</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Job Location:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="job_location"
                                        >
                                            <option value="Offsite">
                                                Offsite
                                            </option>
                                            <option value="Onsite">
                                                Onsite
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Job Number:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="job_no"
                                            placeholder="Enter the job number"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select Job Category:</span
                                        >
                                        <select
                                            class="form-control"
                                            placeholder="Job Category"
                                            v-model="job_category"
                                        >
                                            <option
                                                v-for="c in job_categories"
                                                :value="c.name"
                                            >
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Job Status:</span
                                        >
                                        <select
                                            type="text"
                                            v-model="job_status"
                                            class="form-control"
                                        >
                                            <option value="Completed">
                                                Completed
                                            </option>
                                            <option value="Pending">
                                                Pending
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="from_date"
                                            placeholder="Select from date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="to_date"
                                            placeholder="Select to date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select Status Update Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="date"
                                            placeholder="Select status update date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status Notes:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="status_notes"
                                            placeholder="Search status notes"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Job Status:</span
                                        >
                                        <v-select
                                            v-model="status"
                                            class="form-control"
                                            type="text"
                                            label="status"
                                            :options="statuses"
                                            :reduce="
                                                (statuses) => statuses.status
                                            "
                                            placeholder="Select Status"
                                            :value="
                                                (statuses) => statuses.status
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Branch:</span
                                        >
                                        <v-select
                                            v-model="branch"
                                            class="form-control"
                                            type="text"
                                            label="branch"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                        <!--                                        @input="getAllTechs"-->
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Technician:</span
                                        >
                                        <v-select
                                            v-model="search_tech"
                                            type="text"
                                            label="name"
                                            :options="all_techs"
                                            :reduce="
                                                (all_techs) => all_techs.id
                                            "
                                            placeholder="Select Technician"
                                            :value="(all_techs) => all_techs.id"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group float-left">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            <i class="fa fa-times"></i> Reset
                                        </button>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group float-left">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="getJobs('/api/getAllJobs')"
                                        >
                                            <i class="fa fa-search"></i> Search
                                        </button>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin() ||
                                        $gate.isServiceAdmin() ||
                                        $gate.isServiceManager() ||
                                        $gate.isDOAManager() ||
                                        $gate.isReplacementManager() ||
                                        $gate.isExtWarrAdmin()
                                    "
                                >
                                    <div class="form-group float-left">
                                        <button
                                            class="btn btn-secondary"
                                            style="width: 100% !important"
                                            @click="excel"
                                        >
                                            <i class="fa fa-print"></i> Generate
                                            Excel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />

            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        All Jobs | Total: {{ pagination.total }}
                    </div>
                    <div class="card-body overflow-auto">
                        <img v-if="jobs == ''" src="" />

                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col" style="width: 10%">
                                        Job Added On
                                    </th>
                                    <th scope="col" style="width: 15%">
                                        Job No.
                                    </th>
                                    <th scope="col" style="width: 20%">Item</th>
                                    <th scope="col" style="width: 10%">
                                        Complaint
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Job Category
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Status
                                    </th>
                                    <th scope="col" style="width: 15%">
                                        Status Notes
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Manage
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="job in jobs" :key="job.id">
                                    <td>
                                        {{ job.created_at }}<br /><b>Age:</b>
                                        {{ job.age }} <br /><br />
                                        <h4>{{ job.branch }}</h4>
                                    </td>
                                    <td>
                                        <h5>{{ job.job_no }}</h5>
                                        <br />
                                        <span
                                            class="right badge badge-secondary"
                                            >Customer Details:</span
                                        ><br />
                                        <b>{{ job.customer_name }}</b
                                        ><br />
                                        <b>{{ job.customer_phone }}</b
                                        ><br />
                                        <br />
                                        <span
                                            class="right badge badge-secondary"
                                            >Estimated Delivery:</span
                                        ><br />
                                        <b>{{
                                            job.expected_delivery_date
                                                | formattedDateWithOne
                                        }}</b>
                                    </td>
                                    <td>
                                        <p>{{ job.item_name }}</p>
                                        <br />
                                        <span
                                            class="right badge badge-secondary"
                                            >IMEI/Sl:</span
                                        >
                                        <br />
                                        <p>{{ job.sl_no }}</p>
                                    </td>
                                    <td>{{ job.complaint }}</td>
                                    <td>{{ job.job_category }}</td>
                                    <td
                                        :class="
                                            job.status == 'Completed'
                                                ? 'badge-success'
                                                : 'badge-warning'
                                        "
                                    >
                                        <h5>{{ job.status }}</h5>
                                        <br />
                                        Updated on:
                                        {{
                                            job.status_received_date | timeStamp
                                        }}
                                    </td>
                                    <td>
                                        <p>{{ job.status_notes }}</p>
                                        <br /><br />
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status ==
                                                    'Converted'
                                            "
                                        >
                                            <span
                                                class="right badge badge-secondary"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status ==
                                                    'Action Taken - Case Closed'
                                            "
                                        >
                                            <span
                                                class="right badge badge-success"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status ==
                                                    'Feedback Call Done'
                                            "
                                        >
                                            <span
                                                class="right badge badge-success"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status ==
                                                    'Job Closed and Delivered'
                                            "
                                        >
                                            <span
                                                class="right badge badge-primary"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status ==
                                                    'Feedback Negative - Action Required'
                                            "
                                        >
                                            <span
                                                class="right badge badge-danger"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status == 'Lost'
                                            "
                                        >
                                            <span
                                                class="right badge badge-danger"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                        <h5
                                            v-if="
                                                job.gatepass != null &&
                                                job.gatepass.status !=
                                                    'Converted' &&
                                                job.gatepass.status != 'Lost' &&
                                                job.gatepass.status !=
                                                    'Action Taken - Case Closed' &&
                                                job.gatepass.status !=
                                                    'Feedback Call Done' &&
                                                job.gatepass.status !=
                                                    'Job Closed and Delivered' &&
                                                job.gatepass.status !=
                                                    'Feedback Negative - Action Required'
                                            "
                                        >
                                            <span
                                                class="right badge badge-secondary"
                                                >{{ job.gatepass.status }}</span
                                            >
                                        </h5>
                                    </td>
                                    <td>
                                        <p>
                                            <button
                                                class="btn btn-primary"
                                                style="width: 100% !important"
                                                @click="jobDets(job)"
                                            >
                                                <i class="fa fa-eye"></i> View
                                            </button>
                                        </p>
                                        <p>
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="checkJob(job)"
                                                v-if="job.assigned_to == null"
                                            >
                                                <i class="fa fa-check"></i>
                                                Assign
                                            </button>
                                            <button
                                                class="btn btn-secondary"
                                                style="width: 100% !important"
                                                @click="checkJob(job)"
                                                v-else
                                            >
                                                <i class="fa fa-check"></i>
                                                Re-assign
                                            </button>
                                        </p>
                                        <p>
                                            <button
                                                class="btn btn-primary"
                                                style="width: 100% !important"
                                                @click="customer(job)"
                                                v-if="
                                                    job.customer_id == null ||
                                                    job.comm_address == null
                                                "
                                            >
                                                <i class="fa fa-crosshairs"></i>
                                                Add Customer
                                            </button>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- content here -->
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getJobs(pagination.prevPageUrl)"
                            @next="getJobs(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->
        <div class="modal" tabindex="-1" role="dialog" id="statusModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Status</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <span class="right badge badge-secondary"
                                >Search by Technician:</span
                            >
                            <v-select
                                v-model="search_tech"
                                type="text"
                                label="name"
                                :options="all_techs"
                                :reduce="(all_techs) => all_techs.id"
                                placeholder="Select Technician"
                                :value="(all_techs) => all_techs.id"
                            ></v-select>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Choose Status:</label>
                            <v-select
                                v-model="status"
                                type="text"
                                label="status"
                                :options="statuses"
                                :reduce="(statuses) => statuses.status"
                                placeholder="Select Status"
                                :value="(statuses) => statuses.status"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" @click="update">
                                Update
                            </button>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="assignModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Assign Job</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Choose Technician:</label>
                            <v-select
                                v-model="technician"
                                type="text"
                                label="name"
                                :options="techs"
                                :reduce="(techs) => techs.id"
                                placeholder="Select Technician"
                                :value="(techs) => techs.id"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" @click="selectTech">
                                Select
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isServiceAdmin()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import { saveAs } from "file-saver";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination },

    created() {
        this.user_type = window.user.user_type;
        console.log(this.user_type);
        if (this.user_type == "service-admin") this.job_status = "Pending";
        if (this.$route.params.status != null) {
            this.job_status = this.$route.params.status;
            this.from_date = this.$route.params.from_date;
            this.to_date = this.$route.params.to_date;
            this.job_category = this.$route.params.cat;
        }
        if (this.user_type != "cc-agent") {
            this.getJobs();
        }
        this.getStatuses();
        this.getBranches();
        this.getAllTechs();
        this.getMasterItemCategories();
        this.getDivisions();
        this.getProductList();
        this.getJobCategories();
    },

    data() {
        // let columns = [
        // 	{width:'10%', label:'Job Added On', name:'created_at'},
        // 	{width:'20%', label:'Service Job Particulars', name:'job_no'},
        // 	{width:'20%', label:'Item', name:'item_name'},
        // 	{width:'10%', label:'Expected Delivery Date', name:'expected_delivery_date'},
        // 	{width:'10%', label:'Complaint', name:'complaint'},
        // 	{width:'10%', label:'Job Category', name:'job_category'},
        // 	{width:'10%', label:'Status', name:'status'},
        // 	{width:'10%', label:'Manage', name:'ops'},
        // ];

        return {
            // columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            jobs: [],
            statuses: [],
            results: "",
            status: "",
            curr_job: "",
            item_name: "",
            item_category: "",
            categories: [],
            products: [],
            divisions: [],
            product: "",
            division: "",
            job_no: "",
            status_notes: "",
            to_date: "",
            from_date: "",
            date: "",
            job_category: "",
            branches: [],
            branch: "",
            customer_phone: "",
            tat: "",
            techs: [],
            technician: "",
            job_status: "",
            job_categories: [],
            all_techs: [],
            search_tech: "",
            job_location: "",
            //city: ''
        };
    },

    methods: {
        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getAllTechs() {
            axios
                .post("/api/getTechs", { branch: this.branch })
                .then((response) => {
                    this.all_techs = response.data;
                });
        },

        getJobCategories() {
            axios.post("/api/getAllJobCategories").then((response) => {
                this.job_categories = response.data;
            });
        },

        getMasterItemCategories() {
            axios.post("/api/getMasterItemCategories").then((response) => {
                this.categories = response.data;
            });
        },

        getDivisions() {
            axios.post("/api/getMasterDivisionList").then((response) => {
                this.divisions = response.data;
            });
        },

        getProductList() {
            axios.post("/api/getMasterProductList").then((response) => {
                this.products = response.data;
            });
        },

        excel() {
            axios({
                url: "/api/getServiceJobsExport",
                data: {
                    item_name: this.item_name,
                    job_no: this.job_no,
                    branch: this.branch,
                    from_date: this.from_date,
                    to_date: this.to_date,
                    status: this.status,
                    date: this.date,
                    job_category: this.job_category,
                    customer_phone: this.customer_phone,
                    tat: this.tat,
                    item_category: this.item_category,
                    product: this.product,
                    division: this.division,
                    job_status: this.job_status,
                    search_tech: this.search_tech,
                    job_location: this.job_location,
                    status_notes: this.status_notes,
                },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "jobs.xlsx");
            });
        },

        getJobs(url = "/api/getAllJobs") {
            axios
                .post(url, {
                    results: this.results,
                    item_name: this.item_name,
                    job_no: this.job_no,
                    from_date: this.from_date,
                    to_date: this.to_date,
                    status: this.status,
                    date: this.date,
                    branch: this.branch,
                    job_category: this.job_category,
                    tat: this.tat,
                    customer_phone: this.customer_phone,
                    item_category: this.item_category,
                    product: this.product,
                    division: this.division,
                    job_status: this.job_status,
                    search_tech: this.search_tech,
                    job_location: this.job_location,
                    status_notes: this.status_notes,
                })
                .then((response) => {
                    this.jobs = response.data.data.data;
                    this.configPagination(response.data.data);

                    for (var i = 0; i < this.jobs.length; i++) {
                        var d = new Date(this.jobs[i].created_at);
                        this.jobs[i].created_at = d.toLocaleDateString("en-GB");
                    }
                });
        },

        checkJob(job) {
            if (
                job.job_category != "DOA" &&
                job.job_category != "Replacement" &&
                job.job_category != "O2Protection" &&
                job.job_category != "Stock Complaint"
            )
                this.assign(job, "service-tech");
            else if (job.job_category == "DOA") this.assign(job, "doa-manager");
            else if (job.job_category == "Replacement")
                this.assign(job, "replacement-manager");
            else if (job.job_category == "O2Protection")
                this.assign(job, "ext-warr-admin");
            else if (job.job_category == "Stock Complaint")
                this.assign(job, "");
        },

        assign(job, type) {
            this.curr_job = job.id;
            axios
                .post("/api/getTechs", { branch: job.branch, type: type })
                .then((response) => {
                    this.techs = response.data;
                    $("#assignModal").modal("show");
                });
        },

        selectTech() {
            axios
                .post("/api/assignTech", {
                    technician: this.technician,
                    id: this.curr_job,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Job Assigned",
                        });
                        $("#assignModal").modal("hide");
                        this.getJobs();
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed! Make Sure Technician is Selected!",
                    });
                });
        },

        getStatuses() {
            axios.post("/api/getJobStatusesAll").then((response) => {
                this.statuses = response.data;
            });
        },

        jobDets(job) {
            // this.$router.push("/service-admin/job-profile/"+job.id);
            let route = this.$router.resolve({
                path: "/service/job-profile/" + job.id,
            });
            // let route = this.$router.resolve('/link/to/page'); // This also works.
            window.open(route.href, "_blank");
        },

        update() {
            axios
                .post("/api/updateJobStatus", {
                    id: this.curr_job,
                    status: this.status,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Status Updated",
                        });
                        this.getJobs();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        serviceStatusReport() {
            this.$router.push("/reports/service-status-report");
            // window.open('/reports/gatepass-status-report', "_blank");
        },

        serviceCategoryReport() {
            this.$router.push("/reports/service-category-report");
            // window.open('/reports/gatepass-status-report', "_blank");
        },

        reset() {
            this.results = "";
            this.item_name = "";
            this.job_no = "";
            this.from_date = "";
            this.to_date = "";
            this.status = "";
            this.date = "";
            this.branch = "";
            this.job_category = "";
            this.tat = "";
            this.customer_phone = "";
            this.division = "";
            this.product = "";
            this.item_category = "";
            this.job_status = "";
            this.search_tech = "";
            this.job_location = "";
            this.status_notes = "";
            if (this.user_type != "cc-agent") {
                this.getJobs();
            }
        },

        customer(job) {
            this.$router.push("/service/add-job-customer/" + job.id);
        },
    },
};
</script>
